module.exports = __webpack_public_path__ + "img/NISSAN.df095b2d.png";